import type { ContextFormFieldBaseProps } from '@bambi/component-library/src/components/forms/context/ContextFormFieldBaseProps';
import type { FormFieldControllerRulesProps } from '@bambi/component-library/src/components/forms/context/FormFieldController';
import { FormFieldController } from '@bambi/component-library/src/components/forms/context/FormFieldController';

import { CoreFormFieldLocationTypeahead } from '../core/CoreFormFieldLocationTypeahead';

export const ContextFormFieldLocationTypeahead = ({
  fieldPath,
  rules,
  disabled,
  label,
  inline,
  placeholder,
  helperText,
  colSpan,
}: ContextFormFieldBaseProps) => {
  return (
    <FormFieldController
      name={fieldPath}
      rules={rules as FormFieldControllerRulesProps}
    >
      {({ field, fieldState }) => (
        <CoreFormFieldLocationTypeahead
          label={rules?.required ? `${label} *` : label}
          error={fieldState.error?.message?.toString()}
          onChange={field.onChange}
          value={field.value}
          disabled={disabled}
          placeholder={placeholder}
          inputProps={{ id: fieldPath }}
          inline={inline}
          helperText={helperText}
          colSpan={colSpan}
        />
      )}
    </FormFieldController>
  );
};
